import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import heroImage from '../../assets/hero-home.jpg';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <header className="hero">
      <div className="container hero-grid">
        <div>
          <h1>
            {t('landing.hero.l1')}<br />
            {t('landing.hero.l2')}<br />
            <span className="hi">{t('landing.hero.l3')}</span>
          </h1>
          <p>{t('landing.hero.sub')}</p>
          <div className="cta">
            <Link to="/technicians" className="btn accent">
              <i className="bi bi-search" /> {t('landing.hero.find')}
            </Link>
            <Link to="/register" className="btn ghost">{t('landing.hero.join')}</Link>
          </div>
          <p className="hero-link">
            <a href="#investisseurs">→ {t('landing.hero.invest')}</a>
          </p>
        </div>
        <figure className="hero-visual">
          <img src={heroImage} alt={t('landing.hero.imageAlt')} width="1536" height="1024" />
        </figure>
      </div>
    </header>
  );
}
